const workTaskRules = [
  {
    taskId: '1af64f64-5717-4562-b3fc-2c963f66afa1',
    taskName: 'Instalar',
    jobId: '1af64f64-5717-4562-b3fc-2c963f66afa1',
    jobName: 'Piscina',
    selectJob: false,
    defaultJobs: [
      {
        taskId: '1af64f64-5717-4562-b3fc-2c963f66afa1',
        taskName: 'Instalar',
        jobId: '1af64f64-5717-4562-b3fc-2c963f66afc1',
        jobName: 'Equipamiento',
      },
      {
        taskId: '1af64f64-5717-4562-b3fc-2c963f66afa1',
        taskName: 'Instalar',
        jobId: '1af64f64-5717-4562-b3fc-2c963f66afb1',
        jobName: 'Revestimiento',
      },
    ],
  },
  {
    taskId: '1af64f64-5717-4562-b3fc-2c963f66afa1',
    taskName: 'Instalar',
    jobId: '1af64f64-5717-4562-b3fc-2c963f66aff1',
    jobName: 'Piscina y Equipamiento',
    selectJob: false,
    defaultJobs: [
      {
        taskId: '1af64f64-5717-4562-b3fc-2c963f66afa1',
        taskName: 'Instalar',
        jobId: '1af64f64-5717-4562-b3fc-2c963f66afb1',
        jobName: 'Revestimiento',
      },
    ],
  },
  {
    taskId: '1af64f64-5717-4562-b3fc-2c963f66afa4',
    taskName: 'Visita',
    jobId: '1af64f64-5717-4562-b3fc-2c963f66cda1',
    jobName: 'de Terreno',
    selectJob: true,
    defaultJobs: [],
  },
];

export { workTaskRules };
